@if (showRouterOutlet && configReady) {
  <router-outlet></router-outlet>
}

@if (showSupportWidget) {
  <div #ytWidgetContainer style="position: fixed; z-index: 1000"></div>
}

@if (showDocInsights) {
  <doc-insights-connect
    #docInsightsEl
    [attr.dev-mode]="devMode"
    [attr.widget-key]="docInsightsWidgetKey"
    [attr.doc-id]="docInsightsDocId"
    (onclose)="handleDocInsightsClose()"
    >
  </doc-insights-connect>
}
